"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var formik_1 = require("formik");
var VerticalSpacer_1 = __importDefault(require("../../../../utils/VerticalSpacer"));
var SubmitButton_1 = __importDefault(require("./components/SubmitButton"));
var GenericError_1 = __importDefault(require("./components/GenericError"));
var styles_1 = require("./styles");
var VS_1_AMOUNT = { small: 16, medium: 16, large: 24 };
var FormInner = function (_a) {
    var _b = _a.submitButtonText, submitButtonText = _b === void 0 ? 'Submit' : _b, _c = _a.submitButtonAlign, submitButtonAlign = _c === void 0 ? 'left' : _c, children = _a.children, maxWidth = _a.maxWidth, _d = _a.submitButtonIsCustom, submitButtonIsCustom = _d === void 0 ? false : _d, _e = _a.spacing, spacing = _e === void 0 ? VS_1_AMOUNT : _e;
    var formik = formik_1.useFormikContext();
    return (react_1.default.createElement(VerticalSpacer_1.default, { amount: spacing },
        react_1.default.createElement(styles_1.Wrapper, { "$submitting": formik.isSubmitting, maxWidth: maxWidth }, children),
        react_1.default.createElement(GenericError_1.default, null),
        !submitButtonIsCustom && (react_1.default.createElement(styles_1.Footer, { "$align": submitButtonAlign },
            react_1.default.createElement(SubmitButton_1.default, null, submitButtonText)))));
};
exports.default = FormInner;
